<template>
  <div class="about">
    <h1>A site with events to make the world better </h1>
  </div>
</template>
